module.exports = __webpack_public_path__ + "images/index/img05.49c6f51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/yartai/img05.jpg
// module id = PUkV
// module chunks = 21